export default __webpack_public_path__ + "static/brand-logo-castle-a6351d3bb9bed5059456c41bcfcdc719.png";